import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  files: [],
  total_pages: 0,
  total_results: 0
};
export const useDocumentsListFetch = () => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [searchValue,setSearchValue] = useState('');
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use fetch")
 
  console.log(searchValue)
  const fetchDocuments = async(searchValue)=>{
    try {
      setLoading(true);
      setError(false);
     console.log("binne fetchdocumentslist")
      const data = await API.fetchDocuments(searchValue,"","","",accessToken)
     
      console.log(data)
      setState({  
        ...data
        
      }
      )

      setLoading(false)
      setTrigger(false)

    } catch (error) {
      console.log(error)
      setError(true);
    }
  }

  useEffect(()=>{
    console.log("useEffect is getrigger")
    setState(initialState)
    fetchDocuments(searchValue)
  },[searchValue,trigger]);

return{state,loading,error,setSearchValue,setLoading,setTrigger};


};
